import React from 'react';

const RotatableImage = ({rotationDegrees}) => {
  const WIDTH = 120;

  if (rotationDegrees) {
    return (
      <img
        src={require('./../images/windsock.png')}
        alt='Windsock'
        width={WIDTH}
        style={{
          transform: `rotate(${rotationDegrees}deg)`,
          transition: 'transform 0.5s',
        }}
      />
    );
  }

  return <div style={{ width: WIDTH, textAlign: 'center' }}>N/A</div>;
};

export default RotatableImage;